import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Button, Space, Avatar, Popover, Divider, Typography } from "antd";
import { useAuth } from "../../auth/AuthContext";
import { isPlatformSessionMode } from "../../auth/mode";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import { useMobileMenu } from "../../context/MobileMenuContext";

import {
  setIsCreating,
  setStep,
  resetBreadcrumbs,
} from "../../store/slices/navigationSlice";
import { loadCreationData as loadProjectCreationData } from "../../store/slices/projectSlice";
import { loadCreationData as loadObjectivesCreationData } from "../../store/slices/projectObjectiveSlice";
import { loadCreationData as loadQualificationsCreationData } from "../../store/slices/qualificationSlice";
import { loadCreationData as loadQualificationStepsCreationData } from "../../store/slices/qualificationStepSlice";
import { loadCreationData as loadPagesCreationData } from "../../store/slices/pageSlice";

const WizardHeader = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { toggle: toggleMobileMenu } = useMobileMenu();
  let userEmail = null;
  let userPhoto = null;
  let logoutAppOnly = null;
  let isAuthenticated = false;
  // accessToken not used directly in header UI; keep retrieval minimal
  try {
    const auth = useAuth();
    isAuthenticated = !!auth?.isAuthenticated;
    const u = auth?.user || {};
    // intentionally not using accessToken in header rendering
    const deriveUserEmail = (user) => {
      if (!user) return null;
      const candidates = [
        user.email,
        user.preferred_username,
        user.username,
        user.Email,
        user.emailAddress,
      ];
      for (const c of candidates) {
        if (typeof c === "string" && c.trim().length > 0) return c;
      }
      if (typeof user.name === "string" && user.name.trim().length > 0)
        return user.name;
      return null;
    };
    userEmail = deriveUserEmail(u);
    userPhoto =
      (u.photos && (u.photos.picture || u.photos.thumbnail)) ||
      u.picture ||
      null;
    logoutAppOnly = auth?.logoutAppOnly || null;
    // login available from auth if needed
  } catch (_) {}
  const inPlatform = isPlatformSessionMode();
  const onAuthRoute =
    !!location &&
    (location.pathname === "/login" ||
      location.pathname === "/callback" ||
      location.pathname === "/azure/callback");
  const showMenus = !onAuthRoute && (inPlatform || isAuthenticated);
  const showSignIn = !inPlatform && !isAuthenticated;
  const showRightCluster = showMenus || showSignIn;

  return (
    <div className="bg-white border-b border-gray-200 left-0 bg-white z-10">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center gap-3">
            {showMenus && (
              <Button
                icon={<MenuOutlined />}
                onClick={toggleMobileMenu}
                aria-label="Toggle navigation menu"
              />
            )}
            <Link
              to="/"
              className="text-3xl ml-4 font-bold text-gray-900"
              onClick={() => dispatch(resetBreadcrumbs())}
            >
              CrowdGen Delivery
            </Link>
          </div>

          <div className="flex items-center gap-3">
            {showRightCluster ? (
              <Space size="small" className="flex items-center gap-6">
                {showMenus && (
                  <>
                    <Link
                      to="/"
                      className="ant-btn"
                      onClick={() => dispatch(resetBreadcrumbs())}
                    >
                      Home
                    </Link>
                    <Link
                      to="/create"
                      className="ant-btn"
                      onClick={() => {
                        dispatch(setIsCreating(true));
                        dispatch(setStep(1));
                      }}
                    >
                      Create
                    </Link>
                  </>
                )}
                {isAuthenticated && (
                  <Popover
                    trigger={["hover"]}
                    placement="bottomRight"
                    overlayInnerStyle={{ padding: 12, borderRadius: 8 }}
                    content={
                      <div style={{ minWidth: 220 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <Avatar
                            size={32}
                            style={{ backgroundColor: "#1677ff" }}
                            src={userPhoto || undefined}
                            icon={!userPhoto ? <UserOutlined /> : undefined}
                          >
                            {!userPhoto && userEmail
                              ? String(userEmail).charAt(0).toUpperCase()
                              : null}
                          </Avatar>
                          <div>
                            <div style={{ fontWeight: 600, lineHeight: 1.2 }}>
                              {userEmail || "Signed in"}
                            </div>
                            <Typography.Text
                              type="secondary"
                              style={{ fontSize: 12 }}
                            >
                              Salesforce User
                            </Typography.Text>
                          </div>
                        </div>
                        <Divider style={{ margin: "10px 0" }} />
                        {logoutAppOnly && (
                          <Button
                            type="text"
                            danger
                            style={{ width: "100%", textAlign: "left" }}
                            onClick={logoutAppOnly}
                          >
                            Logout
                          </Button>
                        )}
                      </div>
                    }
                  >
                    <Avatar
                      style={{ backgroundColor: "#1677ff", cursor: "pointer" }}
                      src={userPhoto || undefined}
                      icon={!userPhoto ? <UserOutlined /> : undefined}
                    >
                      {!userPhoto && userEmail
                        ? String(userEmail).charAt(0).toUpperCase()
                        : null}
                    </Avatar>
                  </Popover>
                )}
                {/* {showSignIn && (
                  <Link to="/login" className="ant-btn primary">
                    Sign in
                  </Link>
                )} */}
              </Space>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizardHeader;
